import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function EmpathySection() {
  const vignettes = ['Te despertás cansada aunque dormiste 8 horas', 'Te mirás al espejo y no te reconocés', 'Gastás miles en cremas que no funcionan', 'Sentís que te apagás silenciosamente', 'Probaste todo y nada funciona', "Te resignaste a que 'así es envejecer'"];
  return <Section bg="cream-dark" className="border-t border-gold/10" data-id="element-195">
      <div className="max-w-5xl mx-auto" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <h2 className="text-4xl md:text-5xl font-serif italic font-light text-olive-dark mb-6" data-id="element-198">
            Tal vez esto te está pasando...
          </h2>
          <div className="w-12 h-px bg-gold mx-auto" data-id="element-199" />
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-200">
          {vignettes.map((text, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="glass-card p-6 md:p-8 rounded-2xl flex items-start gap-4" data-id="element-201">
              <span className="text-gold font-serif italic text-3xl leading-none mt-1" data-id="element-202">
                "
              </span>
              <p className="text-charcoal-light font-light text-lg leading-relaxed" data-id="element-203">
                {text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}